import scrollToElement from '../../scrolling';

export function scrollToFirstMessage() { // eslint-disable-line
    const elementToScroll = document.querySelector('[data-automation-id="message-title"]');

    /* istanbul ignore if */
    if (elementToScroll) {
        scrollToElement(elementToScroll, -50);
    }
}
